import _ from 'lodash'
import moment from 'moment'

export const authToken = state => {
  return state.authToken
}

export const loadQuote = state => {
  return JSON.stringify(state.quote.payload)
}

export const quoteIsLoaded = state => {
  return state.flags.quoteIsLoaded
}

export const quoteHasBeenEdited = state => {
  return state.flags.quoteHasBeenEdited
}

export const isNewQuote = state => {
  return state.quote.id === 0
}

export const quoteTemplatesAreNotSet = state => {
  return state.quoteTemplates.length === 0
}

export const fetchQuoteTemplates = state => {
  return state.quoteTemplates
}

export const meta = state => {
  return {
    job_no: state.quote.meta.job_no,
    version: state.quote.version,
    customer: state.quote.meta.customer,
    title: state.quote.meta.title
  }
}

export const aggregates = state => {
  const quote = state.quote.payload
  const pmRatioPercent = quote.pm_ratio / 100

  let itemTypes = state.itemTypes
  let result = {
    hours: quote.hours,
    components: []
  }

  _.forEach(quote.components, function (component) {
    let pmHours = _.ceil(component.hours * pmRatioPercent)
    let componentAggregates = {
      title: component.title,
      hours: component.hours,
      pm: pmHours,
      total_hours: component.hours + pmHours,
      sections: []
    }

    _.forEach(itemTypes, function (itemType) {
      componentAggregates[itemType.value] = 0
      _.forEach(component.sections, function (section) {
        let sectionPmHours = _.ceil(section.hours * pmRatioPercent)
        componentAggregates.sections.push({
          title: section.title,
          hours: section.hours,
          pm: sectionPmHours,
          total_hours: section.hours + sectionPmHours
        })

        _.forEach(section.items, function (item) {
          if (item.type === itemType.value) componentAggregates[itemType.value] += parseInt(item.hours)
        })
      })
    })

    componentAggregates.sections = _.uniqBy(componentAggregates.sections, 'title')

    result.components.push(componentAggregates)
  })

  result['pm'] = _.sumBy(result.components, function (o) { return o.pm })
  result['total_hours'] = result.hours + result.pm
  if (typeof quote.fixed_cost_items !== 'undefined') {
    result['fixed_cost_items'] = quote.fixed_cost_items.items
    result['fixed_cost_items_amount'] = quote.fixed_cost_items.amount
  }

  return result
}

export const params = state => {
  return {
    rate: state.quote.payload.rate,
    pmRatio: state.quote.payload.pm_ratio,
    showHosting: state.quote.payload.show_hosting,
    ...state.options
  }
}

export const itemTypes = state => {
  return state.itemTypes
}

export const flash = state => {
  return state.flash
}

export const flashIsActive = state => {
  return state.flash.active
}

export const quoteLastSaved = state => {
  if (_.isEmpty(state.quote.updated_at)) {
    return 'Never'
  } else {
    return moment(state.quote.updated_at).format('M/D/YY h:mma')
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js